import { fetchBaseQuery, BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { RootState } from '../store';
import { clearAuth } from '../store/authentication/authentication.slice';
import { getSessionToken } from './cookies';
import { jsonParse } from './common';
import { getRequestChecksum } from './encrypt';
import { BaseQueryExtraOptions } from '../types/baseQuery';
import { isServerErrorWithCode, clearAllSessionData } from './rtqErrorHandling';

export const createBaseQueryWithAuth = (baseUrl: string): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> => {
  return async (args, api, extraOptions: BaseQueryExtraOptions = {}) => {
    const state = api.getState() as RootState;
    const { token, checksum: otpSeed } = state.auth;
    
    const sessionAuth = jsonParse(getSessionToken('auth') || '{}');
    const validToken = token || sessionAuth.token || null;
    
    let checksum = '';
    
    const bypassChecksum = extraOptions?.bypassChecksum;
    
    if (otpSeed && !bypassChecksum) {
      try {
        const rawArgsUrl = typeof args === 'string' ? args : args?.url;
        const argsUrl = typeof rawArgsUrl === 'string' ? encodeURI(rawArgsUrl) : rawArgsUrl;
        const argsBody = typeof args === 'string' ? null : args?.body;
        const queryStr = typeof args === 'object' && args?.params ? `?${new URLSearchParams(args.params).toString()}` : '';
        const apiUrl = `${baseUrl}${argsUrl}${queryStr}`.match(/\/api.+/gi)?.[0] ?? '';
        
        checksum = await getRequestChecksum(otpSeed, apiUrl, argsBody) || '';
              } catch (error) {
          
        }
    }

    const baseQuery = fetchBaseQuery({
      baseUrl,
      prepareHeaders: (headers) => {
        if (validToken) {
          headers.set('Authorization', `Bearer ${validToken}`);
        }
        
        if (checksum) {
          headers.set('checksum', checksum);
        }
        
        return headers;
      },
    });

    const result = await baseQuery(args, api, extraOptions);

    if (result.error && result.error.status === 401) {
      api.dispatch(clearAuth({ clearDeviceData: false }));
      window.location.href = '/login';
    }

    if (isServerErrorWithCode(result.error, 2032)) {
      api.dispatch(clearAuth({ clearDeviceData: true }));
      clearAllSessionData();
      window.location.href = '/login';
    }

    return result;
  };
}; 